import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CrossIcon, FlexColumn, FlexRow, MediumText } from '@guryou/html-components';
import { feelThemePalette } from '@guryou/html-theme';
import { useOnboardContext } from 'onboard/context';
import { SystemButton } from 'components/shared';

const ErrorPage = ({ isProvider = false }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { resetState } = useOnboardContext();

  const handleSkip = () => {
    resetState();
    history.push('/management/providers');
  };

  const handleRestart = () => {
    resetState();
  };

  return (
    <FlexColumn>
      <FlexRow
        width="8rem"
        height="8rem"
        margin={5}
        backgroundColor={feelThemePalette.error.main}
        justifyContent="center"
        alignItems="center"
        borderRadius="50%"
      >
        <CrossIcon fontSize="large" htmlColor={feelThemePalette.background.white} />
      </FlexRow>
      <MediumText>{t('ONBOARD.somethingWrong')}</MediumText>
      <FlexRow marginTop={5} justifyContent="center" alignItems="center" style={{ gap: 12 }}>
        {isProvider && (
          <SystemButton variant="ghost" onClick={handleRestart}>
            {t('ONBOARD.tryAgain')}
          </SystemButton>
        )}
        <SystemButton variant="ghost" onClick={handleSkip}>
          {t('ONBOARD.skipForNow')}
        </SystemButton>
      </FlexRow>
    </FlexColumn>
  );
};

export default ErrorPage;
